// components/common/Loading.js - Componente de carga
import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = ({ 
  size = 'lg', 
  variant = 'primary', 
  message = 'Cargando...', 
  fullscreen = false 
}) => {
  const loadingContent = (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <Spinner 
        animation="border" 
        variant={variant} 
        size={size}
        className="mb-3"
      />
      {message && (
        <p className="text-muted mb-0">{message}</p>
      )}
    </div>
  );

  if (fullscreen) {
    return (
      <div 
        className="d-flex align-items-center justify-content-center position-fixed w-100 h-100"
        style={{ 
          top: 0, 
          left: 0, 
          backgroundColor: 'rgba(255, 255, 255, 0.9)', 
          zIndex: 9999 
        }}
      >
        {loadingContent}
      </div>
    );
  }

  return (
    <div className="py-5">
      {loadingContent}
    </div>
  );
};

export default Loading; 